import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { CoreModule } from "../../../core/core.module";
import { CustomerSegmentationModalComponent } from "@modules/uk-finprom/components/customer-segmentation/customer-segmentation.component";
import { InvestorQuestionsComponent } from "@modules/uk-finprom/components/customer-segmentation/components/customer-segmentation-questions/investor-questions/investor-questions.component";
import { EndCryptoJourneyComponent } from "@modules/uk-finprom/components/customer-segmentation/components/customer-segmentation-questions/end-crypto-journey/end-crypto-journey.component";
import { RestrictedInvestorStatementComponent } from "@modules/uk-finprom/components/customer-segmentation/components/customer-segmentation-questions/restricted-investor-statement/restricted-investor-statement.component";
import { InvestorProfileComponent } from "@modules/uk-finprom/components/customer-segmentation/components/customer-segmentation-questions/investor-profile/investor-profile.component";
import { CustomerSegmentationIntroComponent } from "@modules/uk-finprom/components/customer-segmentation/components/customer-segmentation-intro/customer-segmentation-intro.component";
import { InvestorAgreementComponent } from "@modules/uk-finprom/components/customer-segmentation/components/customer-segmentation-questions/investor-agreement/investor-agreement.component";

const components = [
	CustomerSegmentationIntroComponent,
	EndCryptoJourneyComponent,
	InvestorQuestionsComponent,
	InvestorAgreementComponent,
	InvestorProfileComponent,
	RestrictedInvestorStatementComponent,
	CustomerSegmentationModalComponent
];

@NgModule({
	imports: [CommonModule, CoreModule],
	declarations: [...components],
	exports: [...components]
})
export class CustomerSegmentationModule {}
